import React, { useEffect, useState } from "react";
import axios from "axios";
import "./News.css";
import { FaSpinner } from "react-icons/fa6";
import { useMarketToggle } from "../../context/MarketContext";
import { useResult } from "../../context/ResultContext";
import { useNews } from "../../context/NewsContext";
import { useIndicators } from "../../context/IndicatorContext";
import useGlobalSearch from "../../hooks/useGlobalSearch";

import { CiSearch } from "react-icons/ci";
import { FiRefreshCw } from "react-icons/fi";

import { useNavigate } from "react-router-dom";
const CACHE_KEY = "news_cache";
const CACHE_TTL = 1000 * 60 * 30;
const News = () => {
  // const [news, setNews] = useState([]);
  // const [globalNews, setGlobalNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const { market, toggleMarket } = useMarketToggle();
  const [results, setResults] = useState([]);
  const [search, setSearch] = useState("");
  const [activeSymbol, setActiveSymbol] = useState("");
  const [lastUpdated, setLastUpdated] = useState(null);
  const { stockData } = useResult();
  const { news, globalNews } = useNews();
  const {
    fetchSearchQuery,
    searchQuery,
    fetchNewsData,
    newsError,
    newsLoading,
    newsData,
  } = useIndicators();
  const {
    query: globalSearchQuery,
    setQuery: setGlobalSearchQuery,
    results: globalSearchResults,
    loading: globalSearchLoading,
    error: globalSearchError,
    clearResults: clearGlobalSearch,
  } = useGlobalSearch();
  const navigate = useNavigate();

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const isNse = market === "india";

  const formatTimestamp = () => {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    return `${day}-${month}-${year} ${time} IST`;
  };

  const getPlaceholder = () => {
    if (window.matchMedia("(max-width: 300px)").matches) {
      return "Search";
    } else if (window.matchMedia("(max-width: 600px)").matches) {
      return "Search Stocks ";
    }
    return "Search Stocks by Company or Symbol";
  };

  //new default code
  const DEFAULT_SYMBOL = "TCS";
  const DEFAULT_GLOBAL_SYMBOL = "AAPL";
  // useEffect(() => {
  //   if (!isNse) return;

  //   setActiveSymbol(DEFAULT_SYMBOL);
  //   fetchNewsData(DEFAULT_SYMBOL);
  // }, [isNse]);
  useEffect(() => {
    if (isNse) {
      setActiveSymbol(DEFAULT_SYMBOL);
      fetchNewsData(DEFAULT_SYMBOL);
    } else {
      setActiveSymbol(DEFAULT_GLOBAL_SYMBOL);
      fetchNewsData(DEFAULT_GLOBAL_SYMBOL);
      // clear any stale NSE search state when switching markets
      setSearch("");
      setResults([]);
    }
  }, [isNse]);
  const [placeholder, setPlaceholder] = useState(getPlaceholder());
  useEffect(() => {
    const updateText = () => setPlaceholder(getPlaceholder());
    window.addEventListener("resize", updateText);
    return () => window.removeEventListener("resize", updateText);
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    if (isNse) {
      setSearch(value);
    } else {
      setGlobalSearchQuery(value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key !== "Escape") return;
    if (isNse) {
      setResults([]);
    } else {
      clearGlobalSearch();
    }
  };
  // const handleKeyDown = (e) => {
  //   if (e.key === "Escape") {
  //     setResults([]);
  //   }
  // };
  useEffect(() => {
    const timer = setTimeout(async () => {
      if (search.length >= 2 && isNse) {
        try {
          const res = await fetch(`${BASE_URL}/api/search-stocks?q=${search}`);
          const data = await res.json();
          setResults(data);
          // 🔥 THIS WAS MISSING
        } catch (err) {
          console.error("Search error", err);
        }
      } else {
        setResults([]);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [search, isNse]);

  useEffect(() => {
    if (newsData) {
      setLastUpdated(formatTimestamp());
    }
  }, [newsData]);
  const searchQueryData = searchQuery?.results;
  console.log("searchQuerydata", searchQueryData);
  console.log("NEws data", newsData);
  const handleRefresh = () => {
    fetchNewsData(activeSymbol);
  };

  return (
    <>
      <div className="news-search-tab">
        <div className="input-search news-input search-option-input">
          <input
            type="text"
            placeholder={placeholder}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={handleKeyDown}
            style={{
              border: "none",
              background: "inherit",
            }}
          />
          <span>
            <CiSearch />
          </span>

          {isNse && results.length > 0 && (
            <div className="search-dropdown news-input-dropdown">
              {results?.map((item) => (
                <div
                  key={item.id}
                  className="search-dropdown-item news-dropdown-item"
                  onClick={() => {
                    const symbol = item?.symbol;

                    setSearch("");
                    setActiveSymbol(symbol);

                    fetchNewsData(symbol);

                    setResults([]);
                  }}
                >
                  <div className="dropdown-symbol">{item.symbol}</div>
                  <div className="dropdown-company">{item.company}</div>
                </div>
              ))}
            </div>
          )}
          {!isNse &&
            search.trim().length > 0 &&
            Array.isArray(searchQueryData) &&
            searchQueryData.length > 0 && (
              <div className="search-dropdown">
                {searchQueryData.map((item, id) => (
                  <div
                    key={id}
                    className="search-dropdown-item"
                    onClick={() => {
                      navigate(`/globalInfo/${item.symbol}`);
                      setSearch("");
                      fetchSearchQuery(""); // optional cleanup
                    }}
                  >
                    <div className="dropdown-symbol news-dropdown-symbol">
                      {item.symbol}
                    </div>
                    <div className="dropdown-company  news-dropdown-company">
                      {item.longname || item.company}
                    </div>
                  </div>
                ))}
              </div>
            )}
        </div>
      </div>

      {newsLoading ? (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            color: "black",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      ) : newsData ? (
        <div className="news-page-container">
          {/* <div style={{ textAlign: "right", margin: "10px" }}>
            <button
              className="rec-btn"
              // onClick={handleRefresh}
              disabled={loading}
            >
              {loading ? "Refreshing..." : "Refresh Data"}
            </button>
          </div> */}

          {/* <h1 className="news-heading">Live News for  {activeSymbol}</h1> */}
          <div className="news-head-div">
            <h1 className="news-heading">
              Live News{activeSymbol ? ` for ${activeSymbol}` : ""}
            </h1>

            <div className="last-updated-head">
              {lastUpdated && <span>As on {lastUpdated}</span>}
              <FiRefreshCw
                onClick={handleRefresh}
                size={18}
                style={{
                  cursor: "pointer",
                  transition: "0.2s",
                }}
                onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
                onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
              />
            </div>
          </div>

          <div className="news-grid">
            {newsData?.body?.map((item, index) => (
              <a
                key={index}
                href={item.link} // ✅ FIX
                target="_blank"
                rel="noopener noreferrer"
                className="news-card"
              >
                <div className="news-content">
                  <h3 className="news-title">{item.title}</h3>

                  {/* <p className="news-time">
                    {new Date(item.pubDate).toLocaleString("en-IN")}
                  </p>

                  <p className="news-time">Source - {item.source}</p> */}
                  <div className="news-timestamp">
                    <p className="news-time">
                      {new Date(item.pubDate).toLocaleString("en-IN")}
                    </p>

                    <p className="news-time">Source - {item.source}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      ) : (
        <p
          style={{
            textAlign: "center",
            margin: "10px 0",
          }}
        >
          No data available
        </p>
      )}
    </>
  );
};

export default News;
